import { UPDATETEAM_FAIL, UPDATETEAM_SUCCESS } from '../actionTypes';

const initialState = {
    user: null
};

const updateTeamMemberReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATETEAM_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case UPDATETEAM_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }
    return state;
};

export default updateTeamMemberReducer;
